<template>
  <div>
    <v-container fluid style="max-width: 1200px; width: 100%">
      <Header />
      <!-- end of categories -->

      <!-- main content here -->

      <!--small screen search -->
      <!--small screen -->
      <div class="d-flex justify-center" v-if="display.mobile.value">
        <v-img
          :src="require('@/assets/suuq.logo.svg')"
          alt="SUUQ Logo"
          class=""
          @click="logoRoute"
          cover
          max-width="100"
        />
      </div>
      <v-row class="mx-1 mt-6" v-if="display.mobile.value">
        <v-col cols="12">
          <div class="relative">
            <v-text-field
              v-model="newSearchQuery"
              variant="outlined"
              rounded="xl"
              density="comfortable"
              placeholder="Search for anything"
              color="error"
              clearable
              hide-details
              class="mobile-search-field"
              @focus="menuOpen = true"
              @keyup.enter="handleSearch"
              @keydown.esc="menuOpen = false"
              @input="onType"
              style="margin-top: -50px !important"
            >
              <!-- animated icon (prepended) -->
              <template #prepend-inner>
                <div class="search-anim-icon-wrap">
                  <transition name="drop">
                    <img
                      :key="currentIcon"
                      :src="currentIcon"
                      alt=""
                      style="filter: brightness(0) saturate(100%) invert(60%) sepia(100%) saturate(1000%) hue-rotate(15deg) brightness(90%);"
                      class="search-anim-icon"
                    />
                  </transition>
                </div>
              </template>

              <!-- trailing magnifier -->
              <template #append-inner>
                <v-icon size="small">mdi-magnify</v-icon>
              </template>
            </v-text-field>

            <!-- suggestions dropdown -->
            <v-menu
              v-model="menuOpen"
              :close-on-content-click="false"
              activator="parent"
              location="bottom"
              offset="8"
              max-height="320"
            >
              <v-list density="compact" class="py-0">
                <template v-if="suggestionItems.length">
                  <v-list-item
                    v-for="(s, i) in suggestionItems"
                    :key="s.id ?? i"
                    class="text-caption"
                    @click="selectSuggestion(s)"
                  >
                    <template #prepend>
                      <v-avatar :image="s.avatar" size="28" />
                    </template>
                    <v-list-item-title>{{ s.title }}</v-list-item-title>
                    <v-list-item-subtitle>
                      {{ s.category?.name || s.category_name }}
                    </v-list-item-subtitle>
                  </v-list-item>
                </template>

                <v-list-item v-else>
                  <v-list-item-title class="text-caption"
                    >No results</v-list-item-title
                  >
                </v-list-item>
              </v-list>
            </v-menu>
          </div>
        </v-col>
      </v-row>

      <v-row :class="display.mobile.value ? 'ma-0' : 'mx-5'">
        <v-col cols="12" v-if="display.mdAndUp.value">
          <GeneralSearchFilterCardComponent />
        </v-col>

        <!-- Replace the old banner with the new component -->
        <v-col cols="12" v-if="display.mdAndUp.value">
          <PromotionalBannersComponent />
        </v-col>

        <!-- Put mobile categories right under search -->
        <v-col cols="12" v-if="display.mobile.value" class="pt-2 mt-4">
          <PopularCategoriesLinksComponent
            :loading="loading"
            :categories="categories"
            @mobileCategorySelected="handleMobileCategorySelected"
          />
        </v-col>

        <v-col cols="12" v-if="display.mobile.value" class="pa-0">
          <PromotionalBannersComponent />
        </v-col>

        <!-- Keep desktop categories where they were -->
        <v-col cols="12" v-if="display.mdAndUp.value" class="pt-2">
          <PopularCategoriesLinksComponent
            :loading="loading"
            :categories="categories"
            @mobileCategorySelected="handleMobileCategorySelected"
          />
        </v-col>

        <!-- Replace the verification badge section with the new component -->
        <v-col cols="12" v-if="display.mdAndUp.value">
          <VerificationBadgeComponent />
        </v-col>
        <!-- ===== NEW SLIDING SECTIONS ===== -->

        <!-- ✅ SOLUTION 1: Reduce column spacing with custom classes -->
        <!-- Recently Viewed Listings Section -->
        <!-- <v-col cols="12" v-if="display.mdAndUp.value" class="py-2">
            <RecentlyViewedListingsComponent
                :favorites="favoriteListingIds"
                :useTestData="false"
                :dataReady="dataReady"
                :showDebugInfo="false"
                @viewDetails="handleViewDetails"
                @toggleFavorite="handleToggleFavorite"
              />
            </v-col> -->

        <!-- Saved Searches Section -->
        <!-- <v-col cols="12" v-if="display.mdAndUp.value" class="py-2">
              <SavedSearchesComponent
                 :favorites="favoriteListingIds"
                :useTestData="true"
                @viewDetails="handleViewDetails"
                @toggleFavorite="handleToggleFavorite"
              />
            </v-col> -->

        <!-- Popular Category Listings Sections -->
        <v-col cols="12" v-if="display.mdAndUp.value" class="py-2">
          <PopularCategoryListingsComponent
            :favorites="favoriteListingIds"
            :useTestData="false"
            :dataReady="dataReady"
            :maxCategoriesPerPage="6"
            :maxListingsPerCategory="8"
            :showDebugInfo="false"
            @viewDetails="handleViewDetails"
            @toggleFavorite="handleToggleFavorite"
          />
        </v-col>

        <!-- For mobile -->
        <v-col cols="12" v-if="display.mobile.value" class="py-2">
          <PopularCategoryListingsComponent
            :favorites="favoriteListingIds"
            :useTestData="false"
            :dataReady="dataReady"
            :maxCategoriesPerPage="6"
            :maxListingsPerCategory="8"
            :showDebugInfo="false"
            @viewDetails="handleViewDetails"
            @toggleFavorite="handleToggleFavorite"
          />
        </v-col>

        <!--  removed products part -->
      </v-row>

      <!-- end of main content-->
    </v-container>

    <div v-if="!display.mobile.value">
      <FooterComponent></FooterComponent>
    </div>

    <!-- small screen bottom nav -->
    <div></div>
    <FooterMobile v-if="display.mobile.value" />
    <!-- end small screen bottom nav -->
  </div>
</template>
<script setup>
import FooterComponent from "@/components/footer/FooterComponent.vue";
import GeneralSearchFilterCardComponent from "@/components/GeneralSearchFilterCardComponent.vue";
import PromotionalBannersComponent from "@/components/HomeComponentChildren/PromotionalBannersComponent.vue";
import VerificationBadgeComponent from "@/components/HomeComponentChildren/VerificationBadgeComponent.vue";
import NotificationsDropdown from "@/components/NotificationsDropdown.vue";
import SearchesDropdown from "@/components/SearchesDropdown.vue";
import { API_URL } from "@/helpers/api.js";
import CategoryService from "@/services/category.services";
import CityService from "../services/cities.services";
import CountryService from "../services/country.services.js";
import GroupsService from "../services/group.services.js";
import ListingService from "../services/listing.service.js";
import AuthComponent from "./auth/authComponent.vue";
import Header from "./Header.vue";
import FooterMobile from "./footer/FooterMobile.vue";

// Import the reusable sliding component and specific section components
import PopularCategoriesLinksComponent from "@/components/HomeComponentChildren/PopularCategoriesLinksComponent.vue";
import PopularCategoryListingsComponent from "@/components/HomeComponentChildren/PopularCategoryListingsComponent.vue";
import RecentlyViewedListingsComponent from "@/components/HomeComponentChildren/RecentlyViewedListingsComponent.vue";
import SavedSearchesComponent from "@/components/HomeComponentChildren/SavedSearchesComponent.vue";
import SlidingScrollableListingComponent from "@/components/HomeComponentChildren/SlidingScrollableListingComponent.vue";

import { computed, onMounted, ref, watch } from "vue";
import { useRoute, useRouter } from "vue-router";
import { useDisplay } from "vuetify";
import { useStore } from "vuex";

// Vuetify display utility
const display = useDisplay();

//For Saved Listings on the header// By felix Owino

// Store access for new sections
const store = useStore();
const router = useRouter();
const route = useRoute();

const clearPropertySearchState = async () => {
  try {
    // Clear property-related category state
    await store.dispatch("NewCategory/clearSelectedCategory");
    await store.dispatch("NewCategory/clearSubcategories");

    // Reset property filter store completely
    await store.dispatch("propertyFilter/resetFilters");

    // Ensure FilterStore is clean for general search
    await store.dispatch("FilterStore/resetFilters");
  } catch (error) {
    console.warn("Error clearing property search state:", error);
  }
};

const displayListings = computed(
  () => store.getters["savedSearches/displayListings"]
);

const displaySavedListings = ref([]);

// ===== NEW SECTION: Recently Viewed Listings =====
const recentlyViewedLoading = ref(false);
const recentlyViewedError = ref(null);
const useTestDataRecent = ref(true);
// ✅ ADD: Missing reactive variables for the enhanced loadInitialData function
const isInitializing = ref(true);
const initializationError = ref(null);
const lastCacheInvalidation = ref(0);

// ✅ ADD: Store initialization status tracking
const storeInitStatus = ref({
  FilterStore: false,
  PropertyFilterStore: false,
  NewCategory: false,
  savedSearches: false,
  recentlyViewed: false,
  favorites: false,
  homeListings: false,
});

// ✅ CENTRALIZED: Single source of truth for favorites
const favoriteListingIds = computed(() => {
  const favorites = store.getters["favorite/allFavorites"] || [];
  return favorites.map((fav) => fav.listing_id);
});

// ✅ ADD: Missing function for store initialization with retry logic
const initializeStoreWithRetry = async (storeName, action, maxRetries = 3) => {
  let attempts = 0;

  while (attempts < maxRetries) {
    try {
      await store.dispatch(action);
      return true;
    } catch (error) {
      attempts++;
      if (attempts < maxRetries) {
        // Wait before retry with exponential backoff
        const delay = Math.min(1000 * Math.pow(2, attempts - 1), 5000);
        await new Promise((resolve) => setTimeout(resolve, delay));
      }
    }
  }

  return false;
};
// Recently viewed computed properties
const recentlyViewedListings = computed(() => {
  // Get from store first
  const storeRecent = store.getters["recentlyViewed/displayListings"] || [];
  if (storeRecent.length > 0) {
    return storeRecent;
  }

  // Fallback to localStorage
  const recent = getRecentlyViewedFromStorage();
  if (recent.length > 0) {
    return recent;
  }

  // Final fallback to store listings
  const propertyListings =
    store.getters["propertyFilter/filteredPropertyListings"]() || [];
  const filterListings = store.getters["FilterStore/filteredListings"]() || [];

  return [...propertyListings.slice(0, 5), ...filterListings.slice(0, 5)];
});

// ✅ UPDATED: Enhanced loadInitialData function with HomeListingsStore integration
const loadInitialData = async () => {
  isInitializing.value = true;
  initializationError.value = null;

  try {
    // ✅ STEP 1: Initialize ALL core stores in parallel for maximum speed
    const coreStorePromises = [
      // Home listings store (highest priority) - NO CACHING
      store
        .dispatch("homeListings/initialize")
        .then(() => {
          storeInitStatus.value.homeListings = true;
        })
        .catch((error) => {
          storeInitStatus.value.homeListings = false;

          // ✅ ADD: Try force initialization on error
          store
            .dispatch("homeListings/forceInitialize")
            .then(() => {
              storeInitStatus.value.homeListings = true;
            })
            .catch((forceError) => {
              // Force initialization failed
            });
        }),

      // Other core stores in parallel
      store
        .dispatch("NewCategory/fetchCategories")
        .then(() => {
          storeInitStatus.value.NewCategory = true;
        })
        .catch((error) => {
          storeInitStatus.value.NewCategory = false;
        }),

      store
        .dispatch("FilterStore/initialize")
        .then(() => {
          storeInitStatus.value.FilterStore = true;
        })
        .catch((error) => {
          storeInitStatus.value.FilterStore = false;
        }),

      store
        .dispatch("propertyFilter/initialize")
        .then(() => {
          storeInitStatus.value.PropertyFilterStore = true;
        })
        .catch((error) => {
          storeInitStatus.value.PropertyFilterStore = false;
        }),

      store
        .dispatch("favorite/fetchAllFavorites")
        .then(() => {
          storeInitStatus.value.favorites = true;
        })
        .catch((error) => {
          storeInitStatus.value.favorites = false;
        }),
    ];

    // Wait for all core stores to complete (with timeout)
    const coreInitResults = await Promise.allSettled(coreStorePromises);

    // ✅ STEP 3: Initialize dependent stores in parallel
    const dependentStorePromises = [
      store
        .dispatch("savedSearches/initialize")
        .then(() => {
          storeInitStatus.value.savedSearches = true;
        })
        .catch((error) => {
          storeInitStatus.value.savedSearches = false;
        }),

      // store
      //   .dispatch('recentlyViewed/initialize')
      //   .then(() => {
      //     storeInitStatus.value.recentlyViewed = true;
      //     console.log('✅ RecentlyViewed initialized');
      //   })
      //   .catch((error) => {
      //     console.error('❌ RecentlyViewed failed:', error);
      //     storeInitStatus.value.recentlyViewed = false;
      //   }),
    ];

    await Promise.allSettled(dependentStorePromises);

    // ✅ STEP 4: Final status check and logging
    const homeListingsCount = store.getters["homeListings/totalListings"] || 0;
    const homeListingsReady = store.getters["homeListings/hasData"] || false;

    lastCacheInvalidation.value = Date.now();
  } catch (error) {
    initializationError.value = error.message;

    // ✅ FALLBACK: Try to at least initialize home listings if other stores fail
    try {
      await store.dispatch("homeListings/initialize");
    } catch (fallbackError) {
      // Fallback initialization failed
    }
  } finally {
    isInitializing.value = false;
  }
};

// ✅ UPDATED: Enhanced data readiness check prioritizing HomeListingsStore
const dataReady = computed(() => {
  // ✅ PRIMARY: Check HomeListingsStore first (this is what PopularCategoryListingsComponent needs)
  const homeListingsReady = store.getters["homeListings/hasData"];
  const homeListingsLoading = store.getters["homeListings/isLoading"];

  // ✅ SECONDARY: Check other stores for backward compatibility with other components
  const filterReady = store.getters["FilterStore/allListings"]?.length > 0;
  const propertyReady =
    store.getters["propertyFilter/allPropertyListings"]?.length > 0;
  const categoriesReady = store.getters["NewCategory/categories"]?.length > 0;

  // ✅ LOGIC: Home listings store takes priority, but fallback to other stores if needed
  const hasHomeListings = homeListingsReady && !homeListingsLoading;
  const hasOtherData = filterReady || propertyReady || categoriesReady;

  // Component is ready when home listings are loaded OR when we have other data AND not initializing
  return (hasHomeListings || hasOtherData) && !isInitializing.value;
});

// ✅ ADD: Watcher to ensure HomeListingsStore is called on route changes and page refreshes
watch(
  () => route?.path,
  async (newPath, oldPath) => {
    if (!newPath) return; // Safety check

    // If we're on the home page and HomeListingsStore doesn't have data, initialize it
    if (newPath === "/" && !store.getters["homeListings/hasData"]) {
      try {
        await store.dispatch("homeListings/initialize");
      } catch (error) {
        // Failed to initialize on route change
      }
    }
  },
  { immediate: true }
);

// ✅ ADD: Watcher for page visibility changes (handles page refresh)
watch(
  () => document.visibilityState,
  async (newState) => {
    if (newState === "visible" && route?.path === "/") {
      // Check if HomeListingsStore needs initialization
      if (
        !store.getters["homeListings/hasData"] &&
        !store.getters["homeListings/isLoading"]
      ) {
        try {
          await store.dispatch("homeListings/initialize");
        } catch (error) {
          // Failed to initialize after refresh
        }
      }
    }
  }
);

// ✅ ADD: Manual trigger method for debugging (can be called from browser console)
const forceHomeListingsRefresh = async () => {
  try {
    await store.dispatch("homeListings/forceInitialize");
  } catch (error) {
    // Manual refresh failed
  }
};

// ✅ ADD: Expose methods globally for debugging
if (typeof window !== "undefined") {
  window.forceHomeListingsRefresh = forceHomeListingsRefresh;
  window.getHomeListingsStatus = () => {
    const debugInfo = store.getters["homeListings/debugInfo"];
    return debugInfo;
  };
  window.getSimilarListingsStatus = () => {
    const recentlyViewedStatus = store.getters["recentlyViewed/debugInfo"];
    const savedSearchesStatus =
      store.getters["savedSearches/allSearches"]?.length || 0;
    return {
      recentlyViewed: recentlyViewedStatus,
      savedSearches: savedSearchesStatus,
    };
  };
  window.resetSimilarListingsFlag = () => {
    store.getters["recentlyViewed/resetSimilarListingsFetched"]();
  };
}

// Recently viewed methods
const getRecentlyViewedFromStorage = () => {
  try {
    const stored = localStorage.getItem("recentlyViewed");
    return stored ? JSON.parse(stored) : [];
  } catch (error) {
    console.warn("Failed to parse recently viewed from localStorage:", error);
    return [];
  }
};

const saveToRecentlyViewed = (listing) => {
  try {
    let recent = getRecentlyViewedFromStorage();

    // Remove if already exists
    recent = recent.filter((item) => item.id !== listing.id);

    // Add to beginning
    recent.unshift(listing);

    // Keep only last 10
    recent = recent.slice(0, 10);

    localStorage.setItem("recentlyViewed", JSON.stringify(recent));
  } catch (error) {
    console.warn("Failed to save to recently viewed:", error);
  }
};

const fetchRecentlyViewed = async () => {
  recentlyViewedLoading.value = true;
  recentlyViewedError.value = null;

  try {
    // Simulate API call - in real app, fetch from API
    await new Promise((resolve) => setTimeout(resolve, 500));
  } catch (err) {
    recentlyViewedError.value = "Failed to load recently viewed listings";
  } finally {
    recentlyViewedLoading.value = false;
  }
};

// ===== NEW SECTION: Popular Categories =====
const categoryLoading = ref(false);
const categoryError = ref(null);
const useTestDataCategories = ref(true);
const categoryListingsCache = ref({});

// Predefined categories fallback
const predefinedCategories = [
  { id: 1, name: "Motors", slug: "motors" },
  { id: 2, name: "Jobs", slug: "jobs" },
  { id: 3, name: "Property for Sale", slug: "property-for-sale" },
  { id: 4, name: "Property for Rent", slug: "property-for-rent" },
  { id: 5, name: "Community", slug: "community" },
  { id: 6, name: "Classifieds", slug: "classified" },
  { id: 7, name: "Furniture & Garden", slug: "furniture-garden" },
  { id: 8, name: "Mobiles & Tablets", slug: "mobile-tablets" },
];

// Categories computed properties
const availableCategories = computed(() => {
  const storeCategories = store.getters["NewCategory/categories"] || [];
  return storeCategories.length > 0 ? storeCategories : predefinedCategories;
});

const displayCategories = computed(() => {
  return availableCategories.value.slice(0, 6); // Show first 6 categories
});

const getCategoryListings = (category) => {
  // Check cache first
  const cacheKey = `${category.id || category.slug}`;
  if (categoryListingsCache.value[cacheKey]) {
    return categoryListingsCache.value[cacheKey];
  }

  // Get from combined sources
  const allListings = [
    ...(store.getters["propertyFilter/allPropertyListings"] || []),
    ...(store.getters["FilterStore/allListings"] || []),
  ];

  // Filter by category
  const categoryListings = allListings.filter((listing) => {
    return (
      listing.category?.id === category.id ||
      listing.category?.name === category.name ||
      listing.category_id === category.id
    );
  });

  // Cache and return
  categoryListingsCache.value[cacheKey] = categoryListings.slice(0, 8);
  return categoryListingsCache.value[cacheKey];
};

// ✅ FIX: Actually call this method when needed
const fetchCategoryListings = async (category) => {
  categoryLoading.value = true;
  categoryError.value = null;

  try {
    // Clear cache to force refresh
    const cacheKey = `${category.id || category.slug}`;
    delete categoryListingsCache.value[cacheKey];

    // Trigger store refresh
    await Promise.all([
      store.dispatch("FilterStore/refreshAllListings"),
      store.dispatch("propertyFilter/refreshPropertyListings"),
    ]);
  } catch (err) {
    categoryError.value = `Failed to load ${category.name} listings`;
  } finally {
    categoryLoading.value = false;
  }
};

// ===== SHARED METHODS FOR ALL SECTIONS =====
const favorites = computed(() => {
  return store.state.favorites || [];
});

// ===== RECENTLY VIEWED HANDLERS =====
// ===== ENHANCED: Event Handlers =====
const handleViewDetails = async (listing) => {
  try {
    // 1. Save to recently viewed FIRST (immediate)
    saveToRecentlyViewed(listing);

    // 2. Mark as viewed in store (background)
    store.dispatch("recentlyViewed/markAsViewed", listing).catch((error) => {
      // Failed to mark as viewed in store
    });

    // 3. Navigate to listing details
    await router.push({
      name: "ListingDetails",
      params: {
        id: listing.id,
        slug: generateSlug(listing.title),
      },
    });
  } catch (error) {
    // Failed to handle view details
  }
};

const generateSlug = (text) => {
  return text
    ? text
        .toLowerCase()
        .replace(/[^\w\s-]/g, "")
        .replace(/\s+/g, "-")
    : "listing";
};

const handleToggleFavorite = async (listing) => {
  try {
    // ✅ COPIED: Exact logic from your working component
    const listId = store.getters["favoriteList/activeId"];
    const isFavorited = store.getters["favorite/isFavorited"](listing.id);

    if (!isFavorited) {
      await store.dispatch("favorite/addFavorite", {
        listing_id: listing.id,
        favorite_list_id: listId,
      });
      await store.dispatch("alert/success", "Added to favorites");
    } else {
      await store.dispatch("favorite/removeFavorite", listing.id);
      await store.dispatch("alert/success", "Removed from favorites");
    }

    await store.dispatch("favorite/fetchFavorites", listId);
  } catch (error) {
    await store.dispatch("alert/error", "Failed to update favorites");
  }
};

// ===== INITIALIZATION =====
// ✅ ENHANCED: Trigger initialization on component mount
// onMounted(async () => {
//   console.log('🚀 HomeComponent mounted, starting initialization...');
//   await loadInitialData();
//   // ✅ Assign display listings after initialization
//   displaySavedListings.value = displayListings.value;

//   console.log("📊 Listings to display:", displaySavedListings.value);

//   // Add comprehensive debug info about children components
//   console.group("🔍 Child Components Visibility Check");

//   console.log("SavedSearchesComponent should show:", store.getters["savedSearches/shouldShowSection"]);
//   console.log("SavedSearchesComponent data:", {
//     savedSearches: store.getters["savedSearches/allSearches"]?.length || 0,
//     displayListings: store.getters["savedSearches/slidingDisplayListings"]?.length || 0,
//     hasSavedOrSimilar: (
//       (store.state.savedSearches?.savedSearches?.length > 0) ||
//       (store.state.savedSearches?.similarListings?.length > 0)
//     )
//   });

//   console.log("RecentlyViewedComponent should show:", store.getters["recentlyViewed/shouldShowSection"]);
//   console.log("RecentlyViewedComponent data:", {
//     recentlyViewed: store.getters["recentlyViewed/recentlyViewedCount"] || 0,
//     similarListings: store.getters["recentlyViewed/similarListingsCount"] || 0,
//     displayListings: store.getters["recentlyViewed/displayListings"]?.length || 0
//   });

//   console.log("PopularCategoryListingsComponent data ready:", dataReady.value);

//   console.groupEnd();
// });

// ✅ ENHANCED: Trigger initialization on component mount with favorites
onMounted(async () => {
  // ✅ STEP 1: Initialize favorites first (before other data loading)
  try {
    const listId = store.getters["favoriteList/activeId"];
    if (listId) {
      await store.dispatch("favorite/fetchFavorites", listId);
    }
  } catch (error) {
    // Failed to load favorites
  }

  // ✅ STEP 2: Load all other initial data
  await loadInitialData();

  // ✅ STEP 3: Assign display listings after initialization
  displaySavedListings.value = displayListings.value;
});

watch(displayListings, (newVal) => {
  displaySavedListings.value = newVal;
});

// ✅ ADD: Watch for store changes to update cache
watch(
  () => store.getters["FilterStore/allListings"],
  () => {
    // Clear cache when listings change
    categoryListingsCache.value = {};
  },
  { deep: true }
);

watch(
  () => store.getters["propertyFilter/allPropertyListings"],
  () => {
    // Clear cache when property listings change
    categoryListingsCache.value = {};
  },
  { deep: true }
);
</script>
<script>
export default {
  name: "HomeComponent",
  components: {
    FooterComponent,
    AuthComponent,
    NotificationsDropdown,
    SearchesDropdown,
    GeneralSearchFilterCardComponent,
    PromotionalBannersComponent,
    VerificationBadgeComponent,
    PopularCategoriesLinksComponent, // Add the new component
    // Add the new sliding components
    SlidingScrollableListingComponent,
    RecentlyViewedListingsComponent,
    SavedSearchesComponent,
    PopularCategoryListingsComponent,
  },

  data: () => ({
    value: 1,
    listedItems: [],
    locations: [],
    myNotifications: [],
    showLoginDialog: false,
    loading: true,
    theFilteredListings: "",
    unreadNotificationCount: [],
    unreadMessageCount: [],
    API_URL,
    menuOpen: false,
    currentIconIndex: 0,
    currentIcon: null,
    _iconTimer: null,

    // Ecosystem navigation items
    ecosystem: [
      {
        text: "Notification",
        route: "/notification",
        notify: true,
        icon: "mdi-bell-outline",
      },
      {
        text: "My Searches",
        route: "/my-searches",
        icon: "mdi-feature-search-outline",
        search: true,
      },
      {
        text: "Favorites",
        route: "/favorites",
        icon: "mdi-heart-outline",
      },
      {
        text: "Chats",
        route: "/chats",
        icon: "mdi-message-text",
        chaty: true,
      },
      {
        text: "My Ads",
        route: "/my-ads-listings",
        icon: "mdi-view-list-outline",
      },
    ],

    // Filter objects
    filter: {
      categoryId: "",
      location: "",
      purpose: "",
      bedrooms: 0,
      priceRange: 0,
      propertyType: "",
      usage: "",
    },

    defaultFilter: {
      categoryId: "",
      location: "",
      purpose: "",
      bedrooms: 0,
      priceRange: 0,
      propertyType: "",
      usage: "",
    },

    // Bottom navigation for mobile
    bottomNav: [
      {
        name: "Home",
        route: "/",
        icon: "mdi-home",
      },
      {
        name: "Searches",
        route: "",
        slug: "mySearches",
        icon: "mdi-feature-search-outline",
        menu: "search",
      },
      {
        name: "Post an Ad",
        route: "",
        slug: "placeAd",
        icon: "mdi-plus-circle-outline",
      },
      {
        name: "Chats",
        route: "",
        slug: "chatMe",
        icon: "mdi-message-text",
      },
      {
        name: "Menu",
        route: "",
        icon: "mdi-menu",
        menu: "menu",
      },
    ],

    // User menu items
    belowLogout: [
      {
        name: "Notification",
        route: "/notifications",
        slug: "notifyMe",
        icon: "mdi-bell",
      },
      {
        name: "My Ads",
        route: "/my-ads-listings",
        slug: "myAds",
        icon: "mdi-view-list-outline",
      },
      {
        name: "Favorites",
        route: "/favorites",
        slug: "favorites",
        icon: "mdi-heart-outline",
      },

      {
        name: "Searches",
        route: "/my-searches",
        slug: "mySearches",
        icon: "mdi-feature-search-outline",
      },
    ],

    dropDownItems: [
      {
        name: "My Ads",
        route: "/my-ads-listings",
        slug: "myAds",
        icon: "mdi-view-list-outline",
      },
      {
        name: "Chats",
        route: "",
        slug: "chatMe",
        icon: "mdi-message-text",
      },
      {
        name: "My Searches",
        route: "",
        slug: "mySearches",
        icon: "mdi-feature-search-outline",
        menu: "search",
      },
    ],

    // Price ranges for filtering
    priceRanges: [
      { title: "Under $50", value: "0_50" },
      { title: "$50 - $100", value: "50_100" },
      { title: "$100 - $200", value: "100_200" },
      { title: "$200 - $500", value: "200_500" },
      { title: "Above $500", value: "500_10000000" },
    ],

    // UI state
    menuActive: false,
    searchActive: false,
    categories: [],
    listings: [],
    groups: [],
    searchQuery: "",
    newSearchQuery: "",
    newSearchCategory: "",
    filteredItems: [],
    filter: {
      isActive: false,
    },
  }),

  computed: {
    isSearchEnabled() {
      return (
        this.filter.categoryId ||
        this.filter.location ||
        this.filter.propertyType ||
        this.filter.priceRange ||
        this.filter.bedrooms ||
        this.filter.usage
      );
    },

    loggedInUser() {
      return this.$store.state.auth.user;
    },

    user() {
      return this.loggedInUser || {};
    },

    groupedListings() {
      const filteredListings = this.listings.filter((listing) => {
        const searchQueryLower = this.searchQuery.toLowerCase();
        return (
          listing.title.toLowerCase().includes(searchQueryLower) ||
          listing.description.toLowerCase().includes(searchQueryLower)
        );
      });

      return filteredListings.reduce((grouped, listing) => {
        const categorySlug = listing.slug;
        if (!grouped[categorySlug]) {
          grouped[categorySlug] = [];
        }
        grouped[categorySlug].push(listing);
        return grouped;
      }, {});
    },

    filteredListings() {
      return this.listings.filter((listing) => {
        const searchQueryLower = this.searchQuery.toLowerCase();
        return (
          listing.title.toLowerCase().includes(searchQueryLower) ||
          listing.description.toLowerCase().includes(searchQueryLower)
        );
      });
    },

    selectedSearchCategory() {
      return (
        this.categories.find((cat) => cat.id === this.filter.categoryId) || {}
      );
    },

    unreadNotificationCount() {
      return this.$store.getters["notifications/unreadCount"];
    },

    // Map category → avatar icon (adjust filenames to your actual assets)
    iconBySlug() {
      // Using require() to match your current codebase pattern
      const safe = (p) => {
        try {
          return require(p);
        } catch {
          return null;
        }
      };

      return {
        community: safe("@/assets/community.svg"),
        motors: safe("@/assets/motors.svg"),
        jobs: safe("@/assets/jobs.svg"),
        classifieds: safe("@/assets/classifieds.svg"),
        "property-for-rent": safe("@/assets/property_rent.svg"),
        "property-for-sale": safe("@/assets/property_sale.svg"),
      };
    },

    // Build suggestion rows for the v-menu using your existing filter results
    suggestionItems() {
      const list = Array.isArray(this.theFilteredListings)
        ? this.theFilteredListings
        : [];

      return list.slice(0, 8).map((l, i) => {
        const slugGuess =
          l?.category?.slug ||
          (l?.category?.name || "")
            .toString()
            .toLowerCase()
            .replace(/\s+/g, "-");

        const avatar =
          this.iconBySlug[slugGuess] ||
          this.iconBySlug.classifieds ||
          this.iconBySlug.motors;

        return {
          ...l,
          id: l.id ?? i,
          title: l.title,
          category: l.category,
          category_name: l.category?.name ?? l.category_name,
          avatar,
        };
      });
    },
  },

  watch: {
    // Watch newSearchQuery for updates and trigger filtering
    newSearchQuery(newQuery) {
      this.filterItems();
    },
  },

  created() {
    this.getCategories();
    this.getlistings();
    this.getDefaultCountry();
    this.getGroups();

    this.$store.dispatch("filter/setFilterAttributes", this.filter);
  },

  mounted() {
    this._startIconCycle();

    // Initialize notifications listener only if user is authenticated
    if (this.$store.state.auth.user) {
      this.$store.dispatch("notifications/listen");
    }
  },

  beforeUnmount() {
    if (this._iconTimer) clearInterval(this._iconTimer);
    if (this._typeTimer) clearTimeout(this._typeTimer);
  },

  methods: {
    // ===== EXISTING METHODS (keeping all your current functionality) =====
    async clearPropertySearchState() {
      try {
        // Clear property-related category state
        await this.$store.dispatch("NewCategory/clearSelectedCategory");
        await this.$store.dispatch("NewCategory/clearSubcategories");

        // Reset property filter store completely
        await this.$store.dispatch("propertyFilter/resetFilters");

        // Ensure FilterStore is clean for general search
        await this.$store.dispatch("FilterStore/resetFilters");
      } catch (error) {
        console.warn("Error clearing property search state:", error);
      }
    },

    getCategoryName(slug) {
      if (slug && this.categories) {
        const category = this.categories.find((cat) => cat.slug === slug);
        return category ? category.title : "Unknown Category";
      }
    },

    convertToCurrency(value) {
      let number = value;

      if (typeof value === "string") {
        number = parseFloat(value.replace(/[^0-9.-]+/g, ""));
      }

      if (!isNaN(number)) {
        return "USD" + " " + number.toLocaleString("en-US");
      } else {
        return "Invalid number";
      }
    },

    selectItem(item) {
      this.$store.dispatch("category/setSelectedItem", item);
      this.$router.push("/product");
    },

    filterListings() {
      this.$store.dispatch("filter/setFilterAttributes", this.filter);
      this.$router.push("/list");
    },

    selectAttributes(item) {
      this.$store.dispatch("filter/setSelectedAttributes", item);
    },

    // Event handlers for the new component
    handleCategorySelected(category) {
      // Additional logic if needed
    },

    handleMobileCategorySelected(category) {
      // Additional logic if needed
    },

    handleLogout() {
      this.menuActive = false;
      this.$store.commit("auth/logout");
      this.$store.dispatch("resetInactivityTimeout");
      this.$store.dispatch("auth/logout");
      this.$store.dispatch("resetInactivityTimeout");
      this.$router.push("/login");
      this.$store.dispatch("alert/success", "Logout Successfully");
    },

    // ===== API METHODS =====
    getDefaultCountry() {
      return CountryService.defaultCountry().then(
        (response) => {
          if (response.status == 200) {
            this.country = response.data.data;
            this.getcities(this.country.id);
            this.loading = false;
          } else {
            this.country = [];
            this.loading = false;
          }
        },
        (error) => {
          this.country = [];
          if (error.response.status == 401) {
            this.handleLogout();
          }
          this.$store.dispatch("alert/error", error.message);
        }
      );
    },

    getGroups() {
      return GroupsService.index().then(
        (response) => {
          if (response.status == 200) {
            this.groups = response.data.data;
            this.loading = false;
          } else {
            this.groups = [];
            this.loading = false;
          }
        },
        (error) => {
          this.loading = false;
          this.getGroups = [];
          if (error.response.status == 401) {
            this.handleLogout();
          }
          this.$store.dispatch("alert/error", error.message);
        }
      );
    },

    getcities(countryId) {
      return CityService.getCountryCities(countryId).then(
        (response) => {
          if (response.status == 200) {
            this.locations = response.data.data.slice(0, 6);
            this.loading = false;
          } else {
            this.locations = [];
            this.loading = false;
          }
        },
        (error) => {
          this.locations = [];
          if (error.response.status == 401) {
            this.handleLogout();
          }
          this.$store.dispatch("alert/error", error.message);
        }
      );
    },

    getCategories() {
      return CategoryService.getCategories().then(
        (response) => {
          if (response.status == 200) {
            this.categories = response.data.data;
            this.loading = false;
          } else {
            this.categories = [];
            this.loading = false;
          }
        },
        (error) => {
          this.loading = false;
          this.categories = [];
          if (error.response && error.response.status == 401) {
            this.handleLogout();
          }
          this.$store.dispatch(
            "alert/error",
            error.message || "Failed to load categories"
          );
        }
      );
    },

    getlistings() {
      return ListingService.getApprovedOpenListing().then(
        (response) => {
          if (response.status == 200) {
            this.listings = response.data.data;
            this.loading = false;
          } else {
            this.listings = [];
            this.loading = false;
          }
        },
        (error) => {
          this.listings = [];
          if (error.response.status == 401) {
            this.handleLogout();
          }
          this.$store.dispatch("alert/error", error.message);
        }
      );
    },

    async getlistingFile(gridfs_id) {
      return ListingService.getListingFile(gridfs_id).then(
        (response) => {
          if (response.status == 200) {
            const mimeType = response.headers["content-type"];
            const base64Image = this.convertToBase64(response.data, mimeType);
            return base64Image;
            this.loading = false;
          } else {
            this.loading = false;
            return null;
          }
        },
        (error) => {
          this.loading = false;
          if (error.response.status == 401) {
            this.handleLogout();
          }
          return null;
        }
      );
    },

    convertToBase64(binaryData, mimeType) {
      const base64String = btoa(
        new Uint8Array(binaryData).reduce(
          (data, byte) => data + String.fromCharCode(byte),
          ""
        )
      );
      return `data:${mimeType};base64,${base64String}`;
    },

    // ===== NAVIGATION METHODS =====

    loginOrSignup() {
      if (!this.loggedInUser) {
        this.showLoginDialog = true;
      }
    },

    routeTo(route) {
      !this.loggedInUser
        ? this.$router.push(this.$route.query.redirect || "/auth-list")
        : this.$router.push(this.$route.query.redirect || route);
    },

    logoRoute() {
      this.$router.push(this.$route.query.redirect || "/");
    },

    placeAd() {
      !this.loggedInUser
        ? this.$router.push(this.$route.query.redirect || "/auth-list")
        : this.$router.push(this.$route.query.redirect || "/select-your-city");
    },

    notifyMe() {
      !this.loggedInUser
        ? this.$router.push(this.$route.query.redirect || "/auth-list")
        : this.$router.push(this.$route.query.redirect || "/notifications");
    },

    myChats() {
      !this.loggedInUser
        ? this.$router.push(this.$route.query.redirect || "/auth-list")
        : this.$router.push(this.$route.query.redirect || "/chats");
    },

    myAds() {
      !this.loggedInUser
        ? this.$router.push(this.$route.query.redirect || "/auth-list")
        : this.$router.push(this.$route.query.redirect || "/my-ads-listings");
    },

    myFavorites() {
      !this.loggedInUser
        ? this.$router.push(this.$route.query.redirect || "/auth-list")
        : this.$router.push(this.$route.query.redirect || "/favorites");
    },

    mySearches() {
      !this.loggedInUser
        ? this.$router.push(this.$route.query.redirect || "/auth-list")
        : this.$router.push(this.$route.query.redirect || "/my-searches");
    },

    toggle(item) {
      if (item.slug && item.slug === "placeAd") {
        this.placeAd();
        return;
      }

      if (item.slug && item.slug === "notifyMe") {
        this.notifyMe();
        return;
      }

      if (item.slug && item.slug === "mySearches") {
        this.mySearches();
        return;
      }

      if (item.slug && item.slug === "chatMe") {
        this.myChats();
        return;
      }

      if (item.slug && item.slug === "myAds") {
        this.myAds();
        return;
      }

      if (item.slug && item.slug === "favorites") {
        this.myFavorites();
        return;
      }

      if ((!item.route && item.menu === "menu") || "search") {
        item.menu === "menu"
          ? (this.menuActive = !this.menuActive)
          : (this.searchActive = !this.searchActive);
      }
    },

    isLoggedIn() {
      return !!localStorage.getItem("token");
    },

    getInitials(fullName) {
      if (!fullName) return "";

      const words = fullName.trim().split(" ");
      if (words.length === 1) {
        return words[0].charAt(0).toUpperCase();
      }

      return (
        words[0].charAt(0).toUpperCase() + words[1].charAt(0).toUpperCase()
      );
    },

    base64ToFile(base64String, fileType, fileName) {
      const base64Data = base64String.replace(/^data:.+;base64,/, "");
      const byteCharacters = atob(base64Data);
      const byteArray = [...byteCharacters].map((char) => char.charCodeAt(0));
      const blob = new Blob([new Uint8Array(byteArray)], { type: fileType });
      const file = new File([blob], fileName, { type: fileType });
      return file;
    },

    // ===== SEARCH METHODS =====

    searchCategories(query) {
      const lowercasedQuery =
        query && typeof query === "string" ? query.toLowerCase() : "";
      const items = [];

      this.categories.forEach((category) => {
        if (category.title.toLowerCase().includes(lowercasedQuery)) {
          items.push(category.title);
          this.newSearchCategory = category;
        }

        if (category.subcategories) {
          category.subCategories.forEach((subcategory) => {
            if (subcategory.title.toLowerCase().includes(lowercasedQuery)) {
              items.push(subcategory.title);
            }

            if (subcategory.groups) {
              subcategory.groups.forEach((group) => {
                if (group.title.toLowerCase().includes(lowercasedQuery)) {
                  items.push(group.title);
                }
              });
            }
          });
        }
      });

      return items;
    },

    searchListings(query) {
      const lowercasedQuery =
        query && typeof query === "string" ? query.toLowerCase() : "";
      const filteredListings = [];

      this.listings.forEach((listing) => {
        if (listing.title.toLowerCase().includes(lowercasedQuery)) {
          filteredListings.push(listing);
        }
      });
      this.theFilteredListings = filteredListings;

      return filteredListings;
    },

    filterItems() {
      if (this.newSearchQuery) {
        this.filteredItems = this.searchListings(this.newSearchQuery);
      } else {
        this.filteredItems = [];
      }
    },

    handleSelect(item) {
      this.newSearchQuery = item;
    },

    setACategory(category) {
      this.$store.dispatch("filter/setSelectedAttributes", category);
    },

    handleSearch() {
      if (this.theFilteredListings.length > 0) {
        const item = this.theFilteredListings[0];
        this.setACategory(item.category);
        this.$store.dispatch("search/updateSearchCategory", item.title);
        this.$router.push({
          name: "list",
          query: {
            category: item.category.name,
          },
        });
      }
    },

    // Called on input typing; opens menu and debounces your existing filterItems()
    onType() {
      this.menuOpen = true;

      if (this._typeTimer) clearTimeout(this._typeTimer);
      this._typeTimer = setTimeout(() => {
        // Use your existing search pipeline
        if (typeof this.filterItems === "function") this.filterItems();
      }, 180);
    },

    selectSuggestion(item) {
      this.clearPropertySearchState();
      // Only proceed if stores are initialized
      this.newSearchQuery = item.title;
      this.menuOpen = false;

      const isProperty =
        item.category?.slug === "property-for-sale" ||
        item.category?.slug === "property-for-rent" ||
        (item.category?.name &&
          item.category.name.toLowerCase().includes("property")) ||
        !!item.property;

      if (isProperty) {
        // Ensure we have a valid categorySlug for property navigation
        let categorySlug = item.category?.slug;

        // If categorySlug is missing, try to find it from the categories list
        if (!categorySlug && item.category?.id) {
          const categoriesList =
            this.$store.getters["NewCategory/categories"] || [];
          const found = categoriesList.find(
            (cat) => cat.id === item.category.id
          );
          if (found) {
            categorySlug = found.slug;
          }
        }

        // If still no categorySlug, try to determine from category name
        if (!categorySlug && item.category?.name) {
          const categoryName = item.category.name.toLowerCase();
          if (categoryName.includes("sale")) {
            categorySlug = "property-for-sale";
          } else if (categoryName.includes("rent")) {
            categorySlug = "property-for-rent";
          }
        }

        // If we still don't have a categorySlug, show an error and return
        if (!categorySlug) {
          alert("Could not determine property category for navigation.");
          return;
        }

        // Navigate to PropertySearch (the results page) with the valid categorySlug
        this.$router.push({
          name: "PropertySearch",
          params: {
            categorySlug: categorySlug,
          },
          query: {
            q: this.newSearchQuery, // Use the local search query
            categoryId: item.category?.id,
            subcategoryId: item.subcategory?.id,
            source: "dropdown",
          },
        });
      } else {
        try {
          this.$store.dispatch("FilterStore/setSelectedListingItem", item);
        } catch (error) {
          // Silent error handling
        }

        this.$router.push({
          name: "searchResults",
          query: {
            q: this.newSearchQuery, // Use the local search query
            categoryId: item.category?.id || this.selectedCategory?.id, // Use local selectedCategory if needed
            subcategoryId: item.subcategory?.id,
            source: "dropdown",
          },
        });
      }
    },

    // Animated icon cycle for prepend-inner
    _startIconCycle() {
      const icons = [
        // adjust/extend as you like—files must exist
        require("@/assets/community.svg"),
        require("@/assets/motors.svg"),
        require("@/assets/jobs.svg"),
        require("@/assets/classified.svg"),
        require("@/assets/property-for-rent.svg"),
        require("@/assets/property-for-sale.svg"),
      ].filter(Boolean);

      if (!icons.length) return;

      this.currentIcon = icons[this.currentIconIndex];

      if (this._iconTimer) clearInterval(this._iconTimer);
      this._iconTimer = setInterval(() => {
        this.currentIconIndex = (this.currentIconIndex + 1) % icons.length;
        this.currentIcon = icons[this.currentIconIndex];
      }, 1500); // change every 1.5s
    },
  },
};
</script>

<style scoped>
.v-input__icon--append .v-icon {
  color: purple;
}

.custom-card {
  background-color: rgba(0, 0, 0, 0.6);
}

.hover-effect {
  background-color: transparent !important;
  transition: color 0.3s ease;
}

.hover-effect:hover {
  background-color: transparent !important;
  color: blue !important;
}

.v-list-item-title {
  color: inherit;
}

.category-scroll-wrapper {
  display: flex;
  overflow-x: auto;
  padding-bottom: 16px; /* Prevent content from being hidden by scrollbar */
  -webkit-overflow-scrolling: touch; /* Smooth scrolling on mobile */
  scrollbar-width: none; /* Hide scrollbar on Firefox */
  -ms-overflow-style: none; /* Hide scrollbar on IE/Edge */
}

.category-scroll-wrapper::-webkit-scrollbar {
  display: none; /* Hide scrollbar on Chrome, Safari */
}

.category-scroll {
  display: flex;
  flex-wrap: nowrap; /* Keep items in one row */
  gap: 8px; /* Space between items */
  scroll-snap-type: x mandatory; /* Smooth snapping */
}

.category-scroll > * {
  flex-shrink: 0; /* Prevent items from shrinking */
  scroll-snap-align: start;
}

.v-col[cols="auto"] {
  margin-right: 16px; /* Optional: Adjust space between items */
}

.ecosystem {
  display: flex;
  align-items: center;
}

@media (max-width: 600px) {
  .header-fluid-container {
    padding-left: 4px;
    padding-right: 4px;
  }
}

.mobile-search-field :deep(.v-field) {
  border-radius: 999px !important;
}
.search-anim-icon-wrap {
  width: 28px;
  height: 24px;
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: hidden;
}
.search-anim-icon {
  width: 22px;
  height: 22px;
  display: block;
}
.drop-enter-active {
  animation: drop-in 500ms ease-out forwards;
}
.drop-leave-active {
  position: absolute;
  animation: fade-out 180ms ease-in forwards;
}
@keyframes drop-in {
  0% {
    transform: translateY(-12px);
    opacity: 0;
  }
  70% {
    transform: translateY(0);
    opacity: 1;
  }
  85% {
    transform: translateY(-2px);
  }
  100% {
    transform: translateY(0);
  }
}
@keyframes fade-out {
  from {
    opacity: 1;
    transform: translateY(0);
  }
  to {
    opacity: 0;
    transform: translateY(6px);
  }
}
</style>
